//todo : refactoring , add security checks
// import vm from 'vm-browserify';
import { callAPI, buildBlobUrl } from '@cogitate/ui-multi-utils';
import { axiosKeys } from 'ui/data/constants/keys';
// import { getCurrentLine, getCurrentLob } from './helper';

const ACTION_FILES_NAMES = {
  ON_LOAD: 'onLoad.js',
  ON_ELEMENT_CLICK: 'onElementClick.js',
  ON_SCHEMA_CHANGE: 'onSchemaChange.js',
  MANUAL_SUBMIT: 'manualSubmit.js',
  ON_EDIT: 'onEdit.js',
  CANCEL_MANUAL_SUBMIT: 'cancelManualSubmit.js',
  ON_ADD: 'onAdd.js',
  ON_DELETE: 'onDelete.js',
  ON_CONFIRM_DELETE: 'onConfirmDelete.js',
};

export const executeOnChangeVM = async ({ folder = 'reduxActions', subfolder, file, dependencies }) => {
  const cache = executeOnChangeVM.cache || (executeOnChangeVM.cache = {});
  cache[subfolder] = cache[subfolder] || {};
  const actionFile = ACTION_FILES_NAMES[file];

  if (!cache[subfolder][actionFile]) {
    const url = buildBlobUrl('configs', `${folder}/${subfolder}/${actionFile}`);

    // Validate URL or source
    if (!isTrustedSource(url, folder, subfolder)) {
      throw new Error('Untrusted source for action file.');
    }

    try {
      const files = await callAPI(axiosKeys.GetAction, `${url}&useJSONReturnType=false`, null);
      cache[subfolder][actionFile] = files;
    } catch (error) {
      console.error('Error fetching files:', error);
      throw new Error(`Failed to fetch files for ${actionFile}: ${error.message}`);
    }
  }

  const js = cache[subfolder][actionFile];
  if (!js || typeof js !== 'string') {
    throw new Error('Invalid JavaScript code.');
  }
  const functionCache = executeOnChangeVM.functionCache || (executeOnChangeVM.functionCache = {});
  let executeCode = functionCache[js];

  if (!executeCode) {
    try {
      executeCode = new Function(
        ...Object.keys(dependencies),
        `
        return (async () => {
          ${js}
        })();
      `
      );
      functionCache[js] = executeCode;
    } catch (error) {
      console.error('Error creating function:', error.message);
      throw new Error('Function creation error.');
    }
  }

  try {
    await executeCode(...Object.values(dependencies));
  } catch (error) {
    console.error('Error executing code:', error.message);
    throw new Error('Execution error.');
  }
};

// Enhanced helper function to validate trusted sources
function isTrustedSource(_url, _folder, _subfolder) {
  //   const urlObj = new URL(url);
  //   const validPaths = [
  //     `/configs/${folder}/${subfolder}/${getCurrentLine()}/${getCurrentLob()}`,
  //   ];
  //   const isPathValid = validPaths.some((path) =>
  //     urlObj.pathname.startsWith(path)
  //   );
  //   if (!isPathValid) {
  //     console.error('Untrusted source: Path is not valid.');
  //     return false;
  //   }

  return true;
}
